import Loader from 'front/components/Loader/Loader.js'

import 'lie/polyfill'

window.app.loader = Loader
window.app.loader.initialize()
window.app.loader.activate()


// WEBPACK FOOTER //
// ./assets/app/front/Init.js